import { OverlayRef } from '@angular/cdk/overlay';

export class PopupTreeviewRef
{
    constructor (
        public readonly overlayRef: OverlayRef
    )
    {
    }

    public myGetBoundingClientRect (): ClientRect
    {
        return this.overlayRef.overlayElement.getBoundingClientRect();
    }

    public destroy ()
    {
        this.overlayRef.dispose();
    }
}
